$(document).ready(() => {
    $('input,textarea').each((index, element) => {
        element.setAttribute('value', element.value);
    });

    $('input,textarea').change((e) => {
        e.target.setAttribute('value', e.target.value);
    });
});
